export default __webpack_public_path__ + "static/media/pharmadeko.e6164441.png";